import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { handleLogout } from '../../services/api';

const Sidebar = ({ isOpen = false, toggle = () => {}, user = { name: '', profileImage: '' }, loadingUser = false }) => {
  const location = useLocation();

  // Helper function to get correct image URL (same as in Header)
  const getProfileImageUrl = (imagePath) => {
    if (!imagePath) return "https://cdn-icons-png.flaticon.com/512/149/149071.png";
    if (imagePath.startsWith('https')) {
      return imagePath;
    }
    const baseUrl = 'https://backend.adhdrapidcare.com';
    if (imagePath.startsWith('/')) {
      return `${baseUrl}${imagePath}`;
    }
    return `${baseUrl}/${imagePath}`;
  };

  const menuItems = [
    {
      label: 'Dashboard',
      path: '/dashboard',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M4 4h6v6H4V4zm10 0h6v6h-6V4zM4 14h6v6H4v-6zm10 0h6v6h-6v-6z" />
        </svg>
      ),
    },
    {
      label: 'Sessions',
      path: '/sessions',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z" />
        </svg>
      ),
    },
    // {
    //   label: 'Assessment',
    //   path: '/assessment',
    //   icon: (
    //     <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    //       <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z" />
    //     </svg>
    //   ),
    // },
    {
      label: 'Profile',
      path: '/profile',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
        </svg>
      ),
    },
    // {
    //   label: 'Diagnosis',
    //   path: '/diagnosis',
    //   icon: (
    //     <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    //       <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.93 0 3.5 1.57 3.5 3.5S13.93 10 12 10s-3.5-1.57-3.5-3.5S10.07 3 12 3zm0 14c-2.33 0-7 1.17-7 3.5V21h14v-.5c0-2.33-4.67-3.5-7-3.5z" />
    //     </svg>
    //   ),
    // },
    // {
    //   label: 'Appointments',
    //   path: '/appointments',
    //   icon: (
    //     <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    //       <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z" />
    //     </svg>
    //   ),
    // },
    // {
    //   label: 'Prescriptions',
    //   path: '/prescriptions',
    //   icon: (
    //     <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    //       <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z" />
    //     </svg>
    //   ),
    // },
    // {
    //   label: 'Progress',
    //   path: '/progress',
    //   icon: (
    //     <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    //       <path d="M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z" />
    //     </svg>
    //   ),
    // },
    // {
    //   label: 'Profile',
    //   path: '/profile',
    //   icon: (
    //     <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    //       <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
    //     </svg>
    //   ),
    // },
  ];

  return (
    <>
      {/* Desktop Sidebar */}
      <div className="hidden lg:flex flex-col w-28 bg-gray-200 items-center fixed left-0 top-0 h-screen">
        {/* Menu Items - Scrollable */}
        <div className="flex flex-col items-center pt-20 pb-4 flex-1 overflow-y-auto scrollbar-hide">
          {menuItems.map((item, index) => {
            const isActive = location.pathname === item.path;
            return (
              <Link key={index} to={item.path} className="flex flex-col items-center mb-6">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center ${isActive ? 'bg-blue-600 text-white' : 'bg-white text-gray-500'}`}>
                  {item.icon}
                </div>
                <span className={`text-xs mt-1 ${isActive ? 'text-gray-900 font-medium' : 'text-gray-500'}`}>
                  {item.label}
                </span>
              </Link>
            );
          })}
        </div>
        {/* Logout Button - Always at bottom */}
        <div className="pb-6">
          <button 
            onClick={handleLogout}
            className="flex flex-col items-center"
          >
            <div className="w-10 h-10 rounded-full flex items-center justify-center bg-red-500 text-white hover:bg-red-600">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.59L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z" />
              </svg>
            </div>
            <span className="text-xs mt-1 text-gray-500">Logout</span>
          </button>
        </div>
      </div>
      {/* Mobile Sidebar */}
      <div className={`fixed top-0 left-0 h-full w-64 bg-gray-200 pt-20 px-4 z-50 transform transition-transform duration-300 ease-in-out lg:hidden ${isOpen ? 'translate-x-0' : '-translate-x-full'}`}>
        <button className="absolute top-4 right-4 text-xl" onClick={toggle}>✕</button>

        <div className="flex flex-col h-full justify-between">
          <div>
            {menuItems.map((item, index) => {
              const isActive = location.pathname === item.path;
              return (
                <Link
                  key={index}
                  to={item.path}
                  onClick={toggle}
                  className={`flex items-center space-x-3 py-2 px-3 rounded-lg mb-2 ${isActive ? 'bg-blue-600 text-white' : 'text-gray-700 hover:bg-gray-300'}`}
                >
                  {item.icon}
                  <span>{item.label}</span>
                </Link>
              );
            })}
            {/* Mobile Logout */}
            <button
              onClick={() => {
                handleLogout();
                toggle();
              }}
              className="flex items-center space-x-3 py-2 px-3 rounded-lg mb-2 text-red-600 hover:bg-red-50 w-full"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.59L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z" />
              </svg>
              <span>Logout</span>
            </button>
          </div>
          {/* Profile at Bottom */}
          <div className="mb-6 flex items-center space-x-3 px-3">
            {loadingUser ? (
              <>
                <div className="w-10 h-10 rounded-full bg-gray-200 animate-pulse border-2 border-white shadow"></div>
                <div>
                  <div className="h-4 bg-gray-200 rounded w-16 animate-pulse mb-1"></div>
                  <div className="h-3 bg-gray-200 rounded w-12 animate-pulse"></div>
                </div>
              </>
            ) : (
              <>
                <div className="w-10 h-10 rounded-full overflow-hidden border-2 border-white shadow">
                  <img
                    src={getProfileImageUrl(user.profileImage)}
                    alt={user.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      e.target.src = "https://cdn-icons-png.flaticon.com/512/149/149071.png";
                    }}
                  />
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-800">{user.name}</p>
                  <p className="text-xs text-gray-500">Patient</p>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar; 